import { render, staticRenderFns } from "./cascader.vue?vue&type=template&id=065711de"
import script from "./cascader.vue?vue&type=script&lang=js"
export * from "./cascader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports